import {
  Business,
  InsertDriveFileOutlined,
  ShoppingCartOutlined,
  WidgetsOutlined,
  AccountBalance,
  Widgets,
  Person,
  Speed,
  PeopleOutlined,
  Subject,
  LinearScale,
  ErrorOutline,
  ShoppingBagOutlined,
  HandshakeOutlined,
  Percent,
  StickyNote2Outlined,
  CalendarTodayOutlined,
  FilterTiltShiftOutlined,
  PaymentsOutlined,
  StarBorderOutlined,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';
import { ElementType } from 'react';

import { IconId, IconIdUnion } from './Icon.types.ts';

const iconMap: { [key in IconId]: ElementType } = {
  [IconId.contract]: InsertDriveFileOutlined,
  [IconId.purchaseRequisition]: InsertDriveFileOutlined,
  [IconId.negotiationCase]: HandshakeOutlined,
  [IconId.supplier]: Business,
  [IconId.order]: ShoppingCartOutlined,
  [IconId.commodity]: WidgetsOutlined,
  [IconId.demand]: ShoppingBagOutlined,
  [IconId.demandRequestItem]: StickyNote2Outlined,
  [IconId.deliveryDate]: CalendarTodayOutlined,
  [IconId.AccountBalance]: AccountBalance,
  [IconId.Widgets]: Widgets,
  [IconId.Person]: Person,
  [IconId.Speed]: Speed,
  [IconId.PeopleOutlined]: PeopleOutlined,
  [IconId.Subject]: Subject,
  [IconId.InsertDriveFileOutlined]: InsertDriveFileOutlined,
  [IconId.Business]: Business,
  [IconId.LinearScale]: LinearScale,
  [IconId.ErrorOutline]: ErrorOutline,
  [IconId.HandshakeOutlined]: HandshakeOutlined,
  [IconId.Percent]: Percent,
  [IconId.FilterTiltShiftOutlined]: FilterTiltShiftOutlined,
  [IconId.PaymentsOutlined]: PaymentsOutlined,
  [IconId.sourcingProjectAwarding]: StarBorderOutlined,
  [IconId.sourcingProjectItem]: StickyNote2Outlined,
};

export interface IconProps extends SvgIconProps {
  id: IconIdUnion;
}

export const Icon = ({ id, ...props }: IconProps) => {
  const IconComponent = iconMap[id];
  return IconComponent ? <IconComponent {...props} /> : null;
};
